
import { Component, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { ActivatedRoute, Router } from '@angular/router';
import { AddEditSignatoryComponent } from './add-edit-signatory/add-edit-signatory.component';
import { Utils } from '../../../../Utils/utils';
import { LookupKey } from '../../../../shared/constants/lookup-keys';
import { LookupService } from '../../../../core/services/lookup.service';
import { LOVResponseModel } from '../../../../shared/models/lov-response.model';
import { SharedService } from '../../../../shared/services/shared.service';
import { AttachmentService } from '../../../../core/services/attachment.service';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { ApiService } from '../../../../core/services/api.service';
import { DocumentServiceType, FieldValue, ServiceName, ServiceNameEn, SrActionType, SrIOName, UserType } from '../../../../shared/constants/services.enum';
import { OptionFieldComponent } from '../../../../shared/components/controls/option-field/option-field.component';
import { CommonSrRequest, HierarchyWrapper } from '../../../../shared/models/services-request/common.model';
import { AttestationServiceModel } from '../../../../shared/models/services-request/attestation-service.model';
import { SrStatus } from '../../../../shared/constants/status.enum';
import { SrSubmitSuccessModalComponent } from "../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component";
import { CooIntegrationRequestBody, createCooIntegrationRequest } from '../../../../shared/models/coo-integration.model';
import { FileComponent } from '../../../../shared/components/controls/file/file.component';
import { AllowedDocumentType, FolderResponse } from '../../../../shared/models/documents-response.model';
import { SVS_SUBJECT_MAP } from './model/svs-subjects';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { DatePipe, NgClass } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { finalize } from 'rxjs/operators';

@Component({
  standalone: true,
  selector: 'app-attestation',
  imports: [ReactiveFormsModule, NgClass, TranslateModule, ...SHARED_COMPONENTS, AddEditSignatoryComponent, SrSubmitSuccessModalComponent, SkeletonLoaderComponent, DatePipe],
  templateUrl: './attestation.component.html',
  styleUrl: './attestation.component.scss'
})
export class AttestationComponent implements OnDestroy {
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;

  @ViewChildren(OptionFieldComponent) optionFields!: QueryList<OptionFieldComponent>;
  attestationRequest = new CommonSrRequest<AttestationServiceModel, HierarchyWrapper<AttestationServiceModel>>();
  servicePath: 'authenticate-document' | 'certify-document' | 'verify-signature' = 'authenticate-document';
  documentServiceType = DocumentServiceType;
  allFields: any = "";
  userTypeValue = UserType;
  fieldValueConstant: any = FieldValue;
  lookupKey = LookupKey;
  form: FormGroup;
  documentTypes: any = [];
  memberDocumentFolderId: string | null = null;
  memberDocuments: any[] = [];
  memberDocumentsFetched = false;
  govEntities: any = [];
  serviceType: any;
  lang: any = 'en';
  step: number = 1;
  totalSteps: number = 3;
  files: File[] = [];
  newSignatoryModal: boolean = false;
  singatoryList: any[] = [];
  userType: any = "";
  userCSN: any = "";
  userLoginName: string = "";
  showActions: boolean = true;
  downloadingDocId: string | null = null;
  cooIntegrationList: any = [];
  svsSubject: string = "";
  srDetailLoading: boolean = false;
  showNotes: boolean = false;
  srInprgoressAwating: boolean = false;
  private readonly membershipCertificateLabels = [
    'Membership Certificate',
    "شهادة العضوية"
  ]
  auditorExceptionFlag: string;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private lookupService: LookupService,
    private sharedService: SharedService,
    private api: ApiService,
    private attachmentService: AttachmentService
  ) {
    this.lang = localStorage.getItem("selectedLang");
    const primaryAccount = this.sharedService.getPrimaryAccount();
    this.userType = primaryAccount?.['Account Type Code'];
    this.auditorExceptionFlag = primaryAccount?.['DC SVS Auditor Exception'];

    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.userCSN = this.sharedService.getCsnAccountId('csn');

    this.route.data.subscribe(data => {
      this.servicePath = data['mode'];
    });

    //Create form controls
    this.form = this.fb.group({
      documentType: [null],
      otherDocumentName: [''],
      govEntity: [null],
      attestationType: [null],
      subjectType: [null],
      signatory: [null],
      memberNumber: ['', [Validators.maxLength(15)]],
      memberName: [{ value: '', disabled: true }],
      attestationServiceType: [''],
      cooNumber: ['', [Validators.maxLength(50)]],
      documentFileAttesation: [''],
      paymentMethod: [null, [Validators.required]]
    })

    // SR Number in the url
    const routeSrNumber = this.route.snapshot.params?.['sr_no'];
    const routeCsn = this.route.snapshot.params?.['csn'];
    if (routeCsn) {
      this.userCSN = routeCsn;
    }
    if (routeSrNumber) {
      this.srNumber = routeSrNumber;
    }
    // in case of draft
    if (sessionStorage.getItem("srNumber") && this.srNumber == "") {
      let storeSrNumber: any = sessionStorage.getItem("srNumber");
      this.srNumber = storeSrNumber;
    }

    this.route.params.subscribe(params => {
      const srNo = params['sr_no'];
      const csn = params['csn'];
      if (csn) {
        this.userCSN = csn;
      }
      if (srNo && srNo !== this.srNumber) {
        this.srNumber = srNo;
        this.getSRDetail();
      }
    });

    if (this.srNumber) {
      this.getSRDetail();
    }

    if (!this.userCSN && !this.srNumber) {
      this.sharedService.toastMessage('INFO', 'NO_CSN_NUMBER', 'info');
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    }

    if (this.isDocumentService || this.isCertifyService) {
      if (this.userType != this.userTypeValue.MEMBER && this.userType != this.userTypeValue.MEMBER_AR) {
        this.sharedService.toastMessage('INFO', 'ONLY_MEMBER_ALLOWED', 'info', true);
        this.router.navigate([RoutesPath.DASHBOARD]);
        return
      }
      this.serviceType = ServiceName.ATTESTATION_AUTH_CERTIFICATE;
      if (this.serviceType == ServiceName.ATTESTATION_AUTH_CERTIFICATE) {
        this.svsSubject = "Other";
      }
    }
    if (this.isVerifySignService) {
      this.serviceType = ServiceName.ATTESTATION_VERIFY_SIGNATURE;
      if (this.userType == UserType.MEMBER || this.userType == UserType.MEMBER_AR) {
        this.fetchAuditorExceptionLov();
      }
    }

    if (this.isCertifyService) {
      this.serviceType = ServiceName.ATTESTATION_CERTIFY_DOCUMENT; //'True Copy';
      this.svsSubject = "Other";
    }
    this.form.patchValue({ attestationServiceType: this.serviceType });

    if (!this.srNumber) {
      this.loadCsnDependentData();
    }

    this.applyValidation();
    this.getDocumentTypes();
    if (!this.srNumber) {
      this.openFolder();
    }
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit() {
    this.form.valueChanges.subscribe(() => this.applyValidation());
    // this.form.get('documentType')?.valueChanges.subscribe(() => {
    //   this.onDocumentTypeChange(null);
    // });
    if (this.srNumber == "" && this.userCSN) {
      this.submitSRData(this.form.getRawValue(), SrActionType.DRAFT);
    }
  }


  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];
  loadingDoc: boolean = false
  // This method is used to open folder
  openFolder() {
    this.loadingDoc = true;
    let isLabels = !this.srNumber; // true if srNumber is empty
    this.sharedService.getDocuments(this.srNumber, DocumentServiceType.ATTESTATION, isLabels, { svsSubject: this.svsSubject || 'CA' })
      .subscribe({
        next: (response: any) => {
          if (response.success == true) {
            this.loadingDoc = false;
            // If SR exists → response.data, otherwise → response
            this.srFolder = response.data ? response.data : response;
            this.mainFromSectionDocs = this.srFolder.allowedDocumentTypes?.filter((d: any) => !d.forUISection);
          } else {
            this.sharedService.toastMessage("ERROR", response.message, 'error');
          }
        }
      });
  }
  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0 || this.shouldHideDocumentsSection) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];

    // ViewChildren not ready or not fully rendered yet – defer document checks
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }

    let hasMissing = false;
    for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
      const doc = this.mainFromSectionDocs[index];
      const cmp = fileCmps[index];
      // Safety guard; should not happen due to length check above
      if (!cmp) continue;

      if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }

  // This method is used to get document types
  getDocumentTypes() {
    let parentValue: any = ServiceNameEn.ATTESTATION_AUTH_CERTIFICATE;

    if (this.serviceType == ServiceName.ATTESTATION_VERIFY_SIGNATURE) {
      parentValue = ServiceNameEn.ATTESTATION_VERIFY_SIGNATURE;
    }
    if (this.serviceType == ServiceName.ATTESTATION_CERTIFY_DOCUMENT) {
      parentValue = ServiceNameEn.ATTESTATION_CERTIFY_DOCUMENT;
    }

    this.lookupService
      .post<LOVResponseModel>(LookupKey.LOOKUP_URL, {
        ProcessName: "DC Get List Of Values WF",
        Type: this.lookupKey.SUBJECT,
        ParentValue: parentValue//this.serviceType
      })
      .subscribe({
        next: (result: LOVResponseModel) => {
          if (result.SiebelMessage?.['List Of Values'] && !result["Error Message"]) {
            let lovList = result.SiebelMessage['List Of Values'];
            let userType = this.sharedService.getPrimaryAccount()['Account Type Code'];
            if (userType && this.isDocumentService || this.isVerifySignService) {

              if (userType == UserType.MEMBER || userType == UserType.MEMBER_AR) {
                this.documentTypes = lovList.filter((lov: any) => lov["Sub Type"] == UserType.MEMBER || lov["Sub Type"] == UserType.MEMBER_AR);
              } else {
                this.documentTypes = lovList.filter((lov: any) => lov["Sub Type"] == UserType.NON_MEMBER || lov["Sub Type"] == UserType.NON_MEMBER_AR);
              }
              this.loadDocuments();
            } else {
              this.documentTypes = lovList;
            }
            this.mapMemberDocumentsToDocumentTypes();
          }
        }
      })
  }
  loadDocuments() {
    let docType = this.form.get('documentType')?.value;
    if (docType) {
      let selectedLov = this.documentTypes.find((m: any) => m.Value == docType || m.Name == docType)
      if (selectedLov) {
        let motOptionObj = {
          "lovType": "",
          "selectedLov": selectedLov
        }
        this.onDocumentTypeChange(motOptionObj);
      }
    }
  }
  // This method is used to get signatory gov entity using csn
  getSignatoryGovEntity(csn: string) {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get List of Signatory Mob App WF",
        "IncomingHierarchy": {
          "MessageId": Utils.generateUniqueId(),
          "IntObjectName": "DCGetSignatoryIO",
          "MessageType": "Integration Object",
          "IntObjectFormat": "Siebel Hierarchical",
          "ListOfDCGetSignatoryIO": {
            "Account": {
              "CSN": csn
            }
          }
        },
        "SR Sub Type": this.isVerifySignService ? ServiceName.ATTESTATION_VERIFY_SIGNATURE : ServiceName.ATTESTATION_AUTH_CERTIFICATE
      }
    }
    this.api.post<any, any>(
      ApiRoot.DCCICPIntegration,
      this.isVerifySignService ? ApiEndPoints.VERIFY_SIGNATURE : ApiEndPoints.AUTHENTICATE_CERTIFICATE,
      requestPayload
    ).subscribe({

      next: (response: any) => {
        if (response?.SiebelMessage && response['Error Code'] == null) {
          if (this.isVerifySignService) {
            let memberName = this.lang == 'en' ? response.SiebelMessage['Account']["DC Name English"] : response?.SiebelMessage['Account']["DC Name Arabic"];

            this.form.get("memberName")?.setValue(memberName);
            this.singatoryList = response?.SiebelMessage['Account']['Party Relationship To'];
          } else {
            let data = response?.SiebelMessage['Account'];

            data?.forEach((e: any) => {
              const label = this.lang === 'ar' ? e['DC Name Arabic'] : e['DC Name English'];
              e.Name = label;
              e.Value = label;
            });

            // Then assign or push to your target variable
            this.govEntities = [...this.govEntities, ...data];
          }
        }
      },
      // This method is used to handle the error callback
      error: () => {
        this.singatoryList = [];
        this.form.get("memberName")?.setValue("");
      }
    })
  }

  // This method is used to get member signatory
  getMemberSignatory() {
    if (this.form.get('memberNumber')?.value && this.form.get('memberNumber')?.valid) {
      this.getSignatoryGovEntity(this.form.get('memberNumber')?.value)
    } else {
      this.form.markAllAsTouched();
    }
  }

  showCooNumberError: boolean = false;
  selectedCOOSRNo: string = "";
  // This method is used to validate the entered COO number
  getListOfCOO() {
    this.showCooNumberError = false;
    let cooField = this.form.get("cooNumber");
    if (cooField?.invalid && !cooField.value) {
      return;
    }
    let requestPayload: CooIntegrationRequestBody = createCooIntegrationRequest(this.userCSN, cooField?.value);

    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_COO_LIST,
      requestPayload
    ).subscribe({

      next: (response: any) => {
        if (response?.SiebelMessage && response['Error Code'] != "1") {
          this.cooIntegrationList = response.SiebelMessage["DC COO SR Thin BC"];
          let cooNumExist = this.cooIntegrationList.find((c: any) => c["DC COO Number"] == cooField?.value);
          this.selectedCOOSRNo = cooNumExist["SR Number"];
          if (!cooNumExist) {
            this.showCooNumberError = true;
            cooField?.setValue("");
            this.selectedCOOSRNo = "";
          }
        } else {
          cooField?.setValue("");
          this.selectedCOOSRNo = "";
          this.showCooNumberError = true;
        }
      },
      error: () => {
        this.showCooNumberError = true;
        cooField?.setValue("");
      }
    })
  }


  // This method is used to calculate form progress
  get formProgress() {
    if (this.form.disabled) {
      return 100;
    }
    if (!this.form.invalid) {
      if (!this.checkRequiredDocuments()) {
        return 100;
      }
    }
    return Utils.calculateFormProgress(this.step, this.totalSteps)
  }

  // This method is used to check if document service
  get isDocumentService(): boolean {
    return this.servicePath === 'authenticate-document';
  }
  // This method is used to check if certify service
  get isCertifyService(): boolean {
    return this.servicePath === 'certify-document'
  }
  // This method is used to check if verify sign service
  get isVerifySignService(): boolean {
    return this.servicePath === 'verify-signature';
  }

  // This method is used to apply validation
  applyValidation() {
    if (this.isDocumentService) {
      this.toggleRequired(this.form, true, [
        'documentType', 'govEntity'
      ]);
    }
    if (this.isCertifyService) {
      this.toggleRequired(this.form, true, [
        'subjectType'
      ]);
    }
    if (this.isVerifySignService) {
      this.toggleRequired(this.form, true, [
        'documentType', 'signatory'
      ]);

      this.toggleRequired(this.form, this.userType == UserType.NON_MEMBER, [
        'memberNumber'
      ]);

      let isCommercialInv = this.form.get('documentType')?.value == FieldValue.ATTESTATION_DOCUMENT_TYPE_INV_COO || this.form.get('documentType')?.value == FieldValue.ATTESTATION_DOCUMENT_TYPE_INV_COO_AR ? true : false;
      this.toggleRequired(this.form, isCommercialInv, [
        'cooNumber', 'attestationType'
      ]);

      let isOtherDocument = this.form.get('documentType')?.value == FieldValue.ATTESTATION_DOCUMENT_TYPE_OTHER || this.form.get('documentType')?.value == FieldValue.ATTESTATION_DOCUMENT_TYPE_OTHER_AR ? true : false;
      this.toggleRequired(this.form, isOtherDocument, [
        'otherDocumentName'
      ]);


    }
  }
  // This method is used to toggle required using form, condition, and controls
  private toggleRequired(form: FormGroup, condition: boolean, controls: string[]): void {
    Utils.addRemoveValidation(form, condition, controls)
  }
  // This method is used to get encrypted subject using key
  getEncryptedSubject(key: string): string | undefined {
    const entry = SVS_SUBJECT_MAP.find(item => item.encrypted === key);
    return entry?.key;
  }

  private isAuditorReportAllowed(): boolean {
    const memberActivities = this.sharedService.getPrimaryMemberActivities() || [];
    const exceptionNames = this.auditorExceptionLovValues?.map((exActivity: any) => exActivity.Name) || [];

    // Condition1-Activity code match
    const activityMatch = memberActivities.some(
      (memActivity: any) => exceptionNames.includes(memActivity['DC Activity Code'])
    );

    // Condition2-Auditor Exception Flag = 'Y'
    if (activityMatch || this.auditorExceptionFlag === "Y") {
      return true;
    }
    return false;
  }

  // This method is used to handle document type change
  onDocumentTypeChange(option: any) {
    let selectedLov: any = option?.selectedLov || option;
    if (!selectedLov && this.isVerifySignService) {
      const current = this.form.get('documentType')?.value;
      if (current && this.documentTypes && this.documentTypes.length) {
        selectedLov = this.documentTypes.find((d: any) => d.Value === current || d['High'] === current);
      }
    }

    if (selectedLov && this.isVerifySignService) {
      this.svsSubject = selectedLov['High']; //this.getEncryptedSubject(selectedLov['High']) ?? "";

      // Exception check for Auditor report
      if (
        selectedLov['Value'] === FieldValue.AUDITORS_REPORT ||
        selectedLov['Value'] === FieldValue.AUDITORS_REPORT_AR
      ) {
        if (!this.isAuditorReportAllowed()) {
          if (this.auditorExceptionLovValues && this.auditorExceptionFlag != null) {
            this.form.get('documentType')?.setValue(null);
            this.sharedService.toastMessage(
              'ERROR',
              'AUDITOR_REPORT_NOT_ALLOWED',
              'error',
              true
            );
            return;
          }
        }
      }
    }

    if (this.isCertifyService || this.isDocumentService) {
      return;
    }
    this.openFolder();
  }

  // This method is used to handle file upload using file
  handleFileUpload(file: any) { }

  // This method is used to check fields valid
  checkFieldsValid() {
    let stepOneFields = ['documentType', 'govEntity', 'attestationType', 'signatory', 'subjectType', 'cooNumber', 'memberNumber', 'otherDocumentName', 'documentFileAttesation', 'paymentMethod'];
    if (this.optionFields) {
      this.allFields = this.optionFields;
    }
    if (Utils.handleInvalidStep(this.form, this.allFields, stepOneFields)) {
      return false;
    }
    return true;
  }

  // This method is used to handle the next callback
  next() {
    const invalidControls = Utils.getInvalidControls(this.form);
    console.warn('Invalid controls:', invalidControls);
    if (this.checkFieldsValid() && this.form.valid) {
      this.submitSRData(this.form.getRawValue(), SrActionType.SUBMIT);
    }
  }

  // This method is used to save close
  saveClose() {
    this.submitSRData(this.form.getRawValue(), SrActionType.SAVE);
  }

  formSubmitLoader: boolean = false;
  srNumber: any = "";
  isSaved: boolean = false;
  successModal: boolean = false;

  private loadCsnDependentData() {
    if (!this.userCSN) {
      return;
    }

    if (this.isDocumentService || this.isCertifyService) {
      this.getSignatoryGovEntity(this.userCSN);
    }
    if (this.isVerifySignService && (this.userType == UserType.MEMBER || this.userType == UserType.MEMBER_AR)) {
      this.getSignatoryGovEntity(this.userCSN);
    }
    if (this.isCertifyService) {
      this.fetchMemberDocumentsForCertify();
    }
  }

  // This method is used to get sr detail
  getSRDetail() {
    this.srDetailLoading = true;
    this.attestationRequest.body.ProcessName = "DC Community Portal SR Process Wrapper WF";
    this.attestationRequest.body.DCMethod = "QUERY"; //SUBMIT 
    this.attestationRequest.body.DCLoginName = this.userLoginName;
    this.attestationRequest.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';
    let srSubType = ServiceName.ATTESTATION_AUTH_CERTIFICATE;
    if (this.isVerifySignService) {
      srSubType = ServiceName.ATTESTATION_VERIFY_SIGNATURE;
    }
    if (this.isCertifyService) {
      srSubType = ServiceName.ATTESTATION_CERTIFY_DOCUMENT;
    }

    let ServiceRequest: any = {
      "CSN": this.userCSN || "",
      "SR Type": ServiceName.SIGNATURE_OF_VERIFICATION,
      "SR Sub Type": srSubType,
      "SR Number": this.srNumber
    }

    this.attestationRequest.body.DCIncomingHierarchy = {
      MessageId: Utils.generateUniqueId(),
      IntObjectName: "DCCreateSVSIO",
      MessageType: "Integration Object",
      IntObjectFormat: "Siebel Hierarchical",
      ListOfDCCreateSVSIO: {
        "Service Request": ServiceRequest
      }
    }

    this.api.post(
      ApiRoot.ATTESTATION_DCCICREATESVS,
      ApiEndPoints.ATTESTATION_GET_SR_DETAIL,
      this.attestationRequest
    ).subscribe({

      next: (response: any) => {
        if (response['Error Code'] == null && response?.SiebelMessage['Service Request']) {
          this.step = 2;
          let srData = response?.SiebelMessage['Service Request'];
          this.userCSN = srData?.['CSN'] || this.userCSN;
          this.loadCsnDependentData();

          this.form.patchValue({
            documentType: srData?.['DC Subject'] ?? null,
            otherDocumentName: srData?.['DC CRB PRI Name English'] ?? '',
            govEntity: srData["DC SR Member Relationship"] ? (this.lang == 'ar' ? srData["DC SR Member Relationship"]["DC Authentic Signatory Name (Arabic)"] : srData["DC SR Member Relationship"]["DC Authentic Signatory Name (English)"]) : null,
            attestationType: srData?.['DC SVS COO Stamp Type'] ?? null,
            subjectType: srData?.['DC Subject'] ?? '',
            signatory: srData?.["DC SR Member Relationship"] ? srData["DC SR Member Relationship"]["DC Signatory Name (Eng)"] : '',
            memberNumber: srData?.['DC SVS Member Number'] ?? '',
            memberName: srData?.['DC Additional Detail'] ?? '',
            cooNumber: srData?.['DC SVS COO Number'] ?? '',
            paymentMethod: srData?.['DC Payment Method'] ? srData['DC Payment Method'] : null
          })
          if (srData?.['DC SVS Member Number']) {

            if (srData["Status"] == SrStatus.Draft && srData["Status"] == SrStatus.AwaitingClarification || srData["Status"] == SrStatus.Open) {
              this.getMemberSignatory();
            }
            else {
              let selectedSign = Utils.checkIsArray(srData?.["DC SR Member Relationship"]);
              selectedSign.map((s) => {
                let obj = {
                  "DC Related Party Name English": s["DC Signatory Name (Eng)"],
                  "DC Related Party Name Arabic": s["DC Signatory Name (Arabic)"]
                }
                this.singatoryList.push(obj);
              })
            }
          }
          if (this.sharedService.enableNotesOption(srData["Status"])) {
            this.srInprgoressAwating = true;
            this.showNotes = true;
          }

          if (srData["Status"] != SrStatus.Draft && srData["Status"] != SrStatus.AwaitingClarification && srData["Status"] != SrStatus.Open) {
            this.showActions = false;
            this.form.disable(); // disables all fields in the form
            this.step = 3;
          }
          if (this.isDocumentService || this.isCertifyService) {
            this.openFolder();
          }
          this.loadDocuments();
          this.srDetailLoading = false;
        }
      }
    })
  }
  technicalErrorMsg: boolean = false;
  // This method is used to submit sr data using form data and action type
  submitSRData(formData: any, actionType: string) {
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;
    const defaultShowActions = this.showActions;

    if (Utils.hasMaxLengthError(this.form)) {
      this.form.markAllAsTouched();
      return;
    }
    
    if (isActionSubmit && this.checkRequiredDocuments()) {
      this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
      return;
    }
    if (isActionSubmit && this.loadingDoc) {
      return;
    }

    this.attestationRequest.body.ProcessName = "DC Community Portal SR Process Wrapper WF";
    this.attestationRequest.body.DCMethod = isActionSubmit ? "SUBMIT" : "CREATE"; //SUBMIT 
    this.attestationRequest.body.DCLoginName = this.userLoginName;
    this.attestationRequest.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';

    let srSubType = ServiceName.ATTESTATION_AUTH_CERTIFICATE;
    let endPoint = ApiEndPoints.ATTESTATION_CREATE_UPDATE_SR_AUTH_CERTIFICATE;

    let dcSubject = formData.documentType ? formData.documentType : "";

    if (this.isVerifySignService) {
      srSubType = ServiceName.ATTESTATION_VERIFY_SIGNATURE;
      endPoint = ApiEndPoints.ATTESTATION_CREATE_UPDATE_SR_SIGNATURE;
    }
    if (this.isCertifyService) {
      dcSubject = formData.subjectType ? formData.subjectType : "";
      srSubType = ServiceName.ATTESTATION_CERTIFY_DOCUMENT;
      endPoint = ApiEndPoints.ATTESTATION_CREATE_UPDATE_SR_CERTIFY_DOCUMENT;
    }

    let ServiceRequest: any = {
      "CSN": this.userCSN,
      "SR Type": ServiceName.SIGNATURE_OF_VERIFICATION,
      "SR Sub Type": srSubType,
      "DC Subject": dcSubject,//document type
      "SR Number": this.srNumber,
      "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
      "DC CRB PRI Name English": formData.otherDocumentName ? formData.otherDocumentName : "", // other docuemnt name
      "DC Payment Method": formData.paymentMethod ? formData.paymentMethod : ""
    }
    if (srSubType == ServiceName.ATTESTATION_AUTH_CERTIFICATE) {
      let govEntity: any = this.govEntities.find((g: any) => g["DC Name English"] == formData?.govEntity || g["DC Name Arabic"] == formData?.govEntity);
      ServiceRequest["ListOfDC SR Member Relationship"] = {
        "DC SR Member Relationship": [ //govt entity
          {
            "DC Authentic Signatory Name (English)": govEntity ? govEntity['DC Name English'] : "",
            "DC Authentic Signatory Name (Arabic)": govEntity ? govEntity['DC Name Arabic'] : ""
            //govEntity['DC Name Arabic'] : ""
          }
        ]
      }
    }

    if (srSubType == ServiceName.ATTESTATION_VERIFY_SIGNATURE) {
      ServiceRequest["DC SVS COO Stamp Type"] = formData.attestationType ? formData.attestationType : "";
      ServiceRequest["DC SVS COO Number"] = formData.cooNumber ? formData.cooNumber : "";
      ServiceRequest["DC SVS Member Number"] = formData.memberNumber ? formData.memberNumber : "";
      ServiceRequest["DC Additional Detail"] = formData.cooNumber ? this.selectedCOOSRNo : "";

      let signatory: any = this.singatoryList?.find((s: any) => s["DC Related Party Name English"] == formData?.signatory);

      ServiceRequest["ListOfDC SR Member Relationship"] = {
        "DC SR Member Relationship": [ //Signatory 
          {
            "DC Signatory Name (Eng)": signatory ? signatory["DC Related Party Name English"] : "",
            "DC Signatory Name (Arabic)": signatory ? signatory["DC Related Party Name Arabic"] : ""
          }
        ]
      }
    }

    if (this.srNumber) {
      ServiceRequest["SR Number"] = this.srNumber;
    }

    this.attestationRequest.body.DCIncomingHierarchy = {
      MessageId: Utils.generateUniqueId(),
      IntObjectName: "DCCreateSVSIO",
      MessageType: "Integration Object",
      IntObjectFormat: "Siebel Hierarchical",
      ListOfDCCreateSVSIO: {
        "Service Request": ServiceRequest
      }
    }

    if (!isActionDraft) {
      this.showActions = false;
      this.form.disable({ emitEvent: false });
      this.formSubmitLoader = true;
    }
    this.technicalErrorMsg = false;
    this.api.post(
      ApiRoot.ATTESTATION_DCCICREATESVS,
      endPoint,
      this.attestationRequest
    ).subscribe({

      next: (response: any) => {
        if (response['Error Code'] == null && response["DCSRNumber"]) {
          this.isSaved = true;
          if (isActionSave || isActionDraft) {
            if (isActionDraft && this.srNumber == "") {
              this.srNumber = response["DCSRNumber"];
              sessionStorage.setItem("srNumber", response["DCSRNumber"]);
            } else {
              this.srNumber = response["DCSRNumber"];
              if (isActionSave) {
                this.successModal = true;
              }
            }
            this.openFolder();
          } else {
            this.srNumber = response["DCSRNumber"];
            //set sr detail for success page to get ioname
            const { service, serviceAr } = Utils.getServiceLabels(srSubType, this.lang);
            let srDetailObj = {
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              mainService: ServiceName.SIGNATURE_OF_VERIFICATION,
              service: srSubType,
              IOName: SrIOName.ATTESTATION,
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step + 1,
              feeAmount:response?.DCTotalFees,
              memberCSN: this.userCSN
            }
            this.sharedService.setSrResponse(srDetailObj);
            this.removePreviousDocuments();
            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            sessionStorage.removeItem("srNumber");
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
          }
          if (!isActionDraft) {
            this.showActions = defaultShowActions;
            this.form.enable({ emitEvent: false });
            this.form.get('memberName')?.disable({ emitEvent: false });
            this.formSubmitLoader = false;
          }
        } else {
          if (!isActionDraft) {
            this.showActions = defaultShowActions;
            this.form.enable({ emitEvent: false });
            this.form.get('memberName')?.disable({ emitEvent: false });
            this.formSubmitLoader = false;
          }
          this.technicalErrorMsg = true;
        }
      },
      // This method is used to handle the error callback using e
      error: (e) => {
        this.technicalErrorMsg = true;
        if (!isActionDraft) {
          this.showActions = defaultShowActions;
          this.form.enable({ emitEvent: false });
          this.form.get('memberName')?.disable({ emitEvent: false });
          this.formSubmitLoader = false;
        }
      }
    })
  }

  // This method is used to remove previous documents
  removePreviousDocuments() {
    const documentIds = this.srFolder?.documents?.filter(doc => !this.srFolder?.allowedDocumentTypes.find(ad => ad.nameEn === doc.documentType))
      .map(doc => doc.documentId);
    if (documentIds && documentIds.length > 0) {
      let data = {
        "documentServiceType": DocumentServiceType.ATTESTATION,
        "mot": "",
        "svsSubject": this.svsSubject,
        "folderId": this.srFolder.folderId,
        "folderParentId": this.srFolder.folderParentId,
        "folderParentType": this.srFolder.folderParentType,
        "documentId": documentIds
      }
      this.sharedService.deleteBulkDocument(data);
    }
  }
  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }

  // This method is used to determine if deactivate
  canDeactivate(): boolean {
    return this.sharedService.confirmNavigationIfFormDirty(this.form, this.isSaved);
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    sessionStorage.removeItem("srNumber");
  }

  // This method is used to handel file event using document and document field
  handelFileEvent(document: any, documentField: any) {

  }

  get shouldHideDocumentsSection(): boolean {
    const selectedSubject = this.form.get('subjectType')?.value;
    if (!selectedSubject) {
      return false;
    }
    return this.membershipCertificateLabels.includes(selectedSubject);
  }

  // This method is used to handle payment method change using option
  noAdvancePaymentBalance: boolean = false;
  onPaymentMethodChange(value: any) {
    const selectedValue = value;
    if (selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES || selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES_AR) {
      this.noAdvancePaymentBalance = !this.sharedService.hasSufficientAdvanceForServicesBalance();
    } else {
      this.noAdvancePaymentBalance = false;
    }
  }
  closeNotes(e: any) {
    this.showNotes = false;
  }

  //The method use use to exception LOV list
  auditorExceptionLovValues: any = [];
  private fetchAuditorExceptionLov() {
    this.lookupService
      .post<LOVResponseModel>(LookupKey.LOOKUP_URL, {
        ProcessName: "DC Get List Of Values WF",
        Type: LookupKey.DC_SVS_AUDITOR_EXCPTION,
        ParentValue: ""
      })
      .subscribe({
        next: (result: LOVResponseModel) => {
          const list = Utils.checkIsArray(result?.SiebelMessage?.['List Of Values']);
          this.auditorExceptionLovValues = list;
        }
      });
  }


  // This method is used to get member documents
  private fetchMemberDocumentsForCertify(): void {
    if (!this.isCertifyService || this.memberDocumentsFetched || !this.userCSN) {
      return;
    }
    this.memberDocumentsFetched = true;
    this.sharedService
      .getDocuments('', DocumentServiceType.MEMBERSHIP_WALLET, false, {
        memNumber: this.userCSN
      })
      .subscribe({
        next: (response: any) => {
          if (response?.success) {
            const memberDocuments = response.data ?? response;
            this.memberDocumentFolderId = memberDocuments?.folderId ?? null;
            this.memberDocuments = memberDocuments?.documents ?? [];
            this.mapMemberDocumentsToDocumentTypes();
          } else {
            this.memberDocumentsFetched = false;
          }
        },
        error: () => {
          this.memberDocumentsFetched = false;
        }
      });
  }
  // This method is used to map the member document license type and MOA
  private mapMemberDocumentsToDocumentTypes(): void {
    if (!this.isCertifyService || !this.documentTypes?.length || !this.memberDocuments?.length) {
      return;
    }

    const targets = [
      {
        name: 'License',
        matcher: (doc: any) => {
          const type = (doc?.documentType || doc?.NameEn || doc?.nameEn || doc?.label || '').toString().trim().toLowerCase();
          return type === 'trade_license_copy';
        }
      },
      {
        name: 'License Copy',
        matcher: (doc: any) => {
          const type = (doc?.documentType || doc?.NameEn || doc?.nameEn || doc?.label || '').toString().trim().toLowerCase();
          return type === 'trade_license_copy';
        }
      },
      {
        name: 'Memorandum of Association',
        matcher: (doc: any) => {
          const type = (doc?.documentType || doc?.NameEn || doc?.nameEn || doc?.label || '').toString().trim().toLowerCase();
          return type === 'memorandum_of_association';
        }
      }
    ];

    this.documentTypes = this.documentTypes.map((docType: any) => {
      const docTypeName = (docType?.Name || docType?.Value || '').toString().trim();
      const docTypeNameLower = docTypeName.toLowerCase();

      if (docTypeNameLower === 'membership certificate') {
        const primaryAccount = this.sharedService.getPrimaryAccount();
        return {
          ...docType,
          uploadedDate: primaryAccount?.['Customer Since'],
          certificateUrl: primaryAccount?.['DC Certificate URL']
        };
      }

      const target = targets.find(t => t.name.toLowerCase() === docTypeNameLower);
      if (!target) {
        return docType;
      }

      const matchedDoc = this.memberDocuments.find(target.matcher);

      if (matchedDoc?.documentId) {
        return {
          ...docType,
          documentId: matchedDoc.documentId,
          memberFolderId: matchedDoc.memberFolderId || this.memberDocumentFolderId,
          documentServiceType: DocumentServiceType.MEMBERSHIP_WALLET,
          uploadedDate: this.parseUploadedDate(matchedDoc.uploadedDate)
        };
      }
      return docType;
    });
  }

  // This method is for download membership certificate
  downloadCertificate(url: any): void {
    if (!url) {
      return;
    }
    window.open(url, '_blank', 'noopener');
  }

  // method for download member documents
  downloadMappedDocument(docType: any): void {
    const documentId = docType?.documentId;
    const folderId = docType?.memberFolderId || this.srFolder?.folderId;
    if (!documentId || !folderId) {
      return;
    }

    const serviceType = docType?.documentServiceType || DocumentServiceType.ATTESTATION;
    const encryptionOptions: any = {};
    if (serviceType === DocumentServiceType.MEMBERSHIP_WALLET) {
      encryptionOptions.memNumber = this.userCSN;
    } else {
      encryptionOptions.svsSubject = this.svsSubject;
      encryptionOptions.srNumber = this.srNumber;
    }

    this.downloadingDocId = documentId;
    this.sharedService
      .getEncryption(serviceType, encryptionOptions)
      .subscribe({
        next: (encryptionResponse: any) => {
          if (!encryptionResponse) {
            this.downloadingDocId = null;
            return;
          }
          const response: any = Utils.decodeAndStringify(encryptionResponse);
          const validation = environment.documentEncryption
            ? response.validation
            : Utils.getDubaiDateTime();

          this.attachmentService
            .downloadFile(documentId, folderId, validation)
            .pipe(finalize(() => (this.downloadingDocId = null)))
            .subscribe({
              next: (blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = (docType?.Name || docType?.Value || 'document') + '.pdf';
                a.click();
                window.URL.revokeObjectURL(url);
              },
              error: () => {
                this.downloadingDocId = null;
              }
            });
        },
        error: () => {
          this.downloadingDocId = null;
        }
      });
  }

  private parseUploadedDate(dateStr: string): Date {
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day);
  }
}
